
export function isNil(object) {
    return object === null || object === undefined;
}

export function notNil(message) {
    return (object) => {
        if (isNil(object)) {
            throw Error(message);
        }
    }
}
